export default function initModal() {
  const modalTriggers = document.querySelectorAll('[data-toggle="modal"]');

  modalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = trigger.getAttribute("data-target");
      const modal = document.querySelector(targetId);

      if (modal) {
        openModal(modal);
      }
    });
  });

  // Auto-show modals with data-frequently attribute
  const autoModals = document.querySelectorAll(".modal[data-frequently]");
  autoModals.forEach((modal) => {
    const frequently = parseInt(modal.dataset.frequently, 10) || 1;
    const seconds = parseFloat(modal.dataset.seconds) || 0;
    const modalId = modal.id || "modal";
    const storageKey = `modal_shown_${modalId}`;

    // Get current shown count from localStorage
    const shownCount = parseInt(localStorage.getItem(storageKey), 10) || 0;

    // Only show if under the frequency limit
    if (shownCount < frequently) {
      setTimeout(() => {
        openModal(modal);
        // Increment shown count
        localStorage.setItem(storageKey, shownCount + 1);
      }, seconds * 1000);
    }
  });

  function openModal(modal) {
    // Check data-backdrop attribute (default: true)
    const backdrop = modal.getAttribute("data-backdrop");
    const allowBackdropClose = backdrop !== "static";

    // Check data-keyboard attribute (default: true)
    const keyboard = modal.getAttribute("data-keyboard");
    const allowKeyboardClose = keyboard !== "false";

    // Save scroll position
    const scrollY = window.scrollY;

    // Get scrollbar width before hiding overflow
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    // Add modal-open class to body
    document.body.classList.add("modal-open");
    document.body.style.overflow = "hidden";

    // Add padding to compensate for scrollbar
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    // Show modal with fade animation
    modal.style.display = "flex";
    setTimeout(() => {
      modal.classList.add("show");
    }, 10);

    // Close button
    const closeButton = modal.querySelector(".modal-close");
    closeButton?.addEventListener("click", handleClose);

    // Overlay click
    if (allowBackdropClose) {
      modal.addEventListener("click", handleBackdrop);
    }

    // ESC key
    if (allowKeyboardClose) {
      document.addEventListener("keydown", handleEscape);
    }

    function handleClose(e) {
      e.preventDefault();
      closeModal();
    }

    function handleBackdrop(e) {
      if (e.target === modal) {
        closeModal();
      }
    }

    function handleEscape(e) {
      if (e.key === "Escape") {
        closeModal();
      }
    }

    function closeModal() {
      // Remove listeners
      closeButton?.removeEventListener("click", handleClose);
      modal.removeEventListener("click", handleBackdrop);
      document.removeEventListener("keydown", handleEscape);

      // Blur active element to prevent scroll jump
      document.activeElement?.blur();

      // Close animation
      modal.classList.remove("show");

      setTimeout(() => {
        modal.style.display = "none";
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";

        // Restore scroll position
        window.scrollTo(0, scrollY);
      }, 150);
    }
  }
}
